import React from 'react';
import type { DoctorProfile } from '../../../types/doctorOnboarding';

type Props = {
  profile: DoctorProfile | null;
  completionPercentage: number;
  missingRequirements: string[];
  canSubmit: boolean;
  onboardingStatus: string | null;
  verificationNotes: string | null;
  nextAction: string | null;
  submitting: boolean;
  onSubmit: () => void;
  onBack: () => void;
};

export default function ReviewSubmitStep({
  profile,
  completionPercentage,
  missingRequirements,
  canSubmit,
  onboardingStatus,
  verificationNotes,
  nextAction,
  submitting,
  onSubmit,
  onBack,
}: Props) {
  return (
    <div>
      <div className="onboarding-section">
        <h3>Review & Submit</h3>
        <p className="onboarding-step-label">
          Completion: {completionPercentage}% {profile?.full_name ? `• ${profile.full_name}` : ''}
        </p>
        {missingRequirements.length > 0 && (
          <div className="onboarding-error">
            Missing required items: {missingRequirements.join(', ')}
          </div>
        )}
        {onboardingStatus && (
          <p className="onboarding-step-label">
            Onboarding status: {onboardingStatus}
          </p>
        )}
        {verificationNotes && (
          <div className="onboarding-error">Notes: {verificationNotes}</div>
        )}
        {nextAction && (
          <p className="onboarding-step-label">Next: {nextAction}</p>
        )}
      </div>

      <div className="step-actions">
        <button type="button" className="btn-secondary" onClick={onBack}>
          Back
        </button>
        <button
          type="button"
          className="btn-primary"
          onClick={onSubmit}
          disabled={!canSubmit || submitting}
        >
          {submitting ? 'Submitting...' : 'Submit for verification'}
        </button>
      </div>
    </div>
  );
}
